<mat-toolbar>
  <span>{{ "Adhérents" | uppercase }}</span>
  <span class="spacer"></span>
  @if (activiteAdherent === "gpo") {
    <app-filiale-selector></app-filiale-selector>
  }
</mat-toolbar>

<div class="content">
  <mat-form-field appearance="outline">
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      [ngModel]="globalFilter"
      (ngModelChange)="applyFilter($event)"
      #input
    />
    @if (globalFilter) {
      <button
        matSuffix
        mat-icon-button
        class="close-button"
        aria-label="Clear"
        (click)="applyFilter((globalFilter = ''))"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
    <!-- Nom Column -->
    <ng-container matColumnDef="nom">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
      <td mat-cell *matCellDef="let element">
        {{ element.nom }}
      </td>
    </ng-container>
    <!-- Code postal Column -->
    <ng-container matColumnDef="cp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Code Postal</th>
      <td mat-cell *matCellDef="let element">{{ element.cp }}</td>
    </ng-container>
    <!-- Ville Column -->
    <ng-container matColumnDef="ville">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ville</th>
      <td mat-cell *matCellDef="let element">{{ element.ville }}</td>
    </ng-container>
    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      tabindex="0"
      role="button"
      (click)="goToAdherentB2C(row)"
      (keydown.enter)="goToAdherentB2C(row)"
      (keydown.space)="goToAdherentB2C(row)"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" colspan="12">
        {{ NO_DATA }} "{{ input.value }}"
      </td>
    </tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons>
  </mat-paginator>
</div>
